module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "coastal-flooding-and-slr-cover.be877b07.jpg";